import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { VariantProps, tv } from "tailwind-variants";

const badge = tv({
  slots: {
    base: "inline-flex min-w-max flex-row items-center gap-10 rounded-full border px-15 py-3",
  },
  variants: {
    variant: {
      default: "border-gray/50 bg-gray-light text-gray-dark",
      success: "border-green/50 bg-green-light text-green-dark",
      warning: "border-orange/50 bg-orange-light text-orange-dark",
      error: "border-red/50 bg-red-light text-red-dark",
      info: "border-primary/50 bg-primary-light text-primary-dark",
    },
    textSize: {
      small: "text-sm",
      base: "text-base",
    },
  },
  defaultVariants: {
    variant: "default",
    textSize: "small",
  },
});

export interface IBadgeType {
  value: VariantProps<typeof badge>["variant"];
  type: string;
};

interface IProps {
  variant?: VariantProps<typeof badge>["variant"];
  textSize?: VariantProps<typeof badge>["textSize"];
  icon?: IconProp;
  iconPosition?: "start" | "end";
  children: ReactNode;
}

const Badge = ({
  variant,
  textSize,
  icon,
  iconPosition = "start",
  children,
}: IProps) => {
  const { base } = badge({ variant, textSize });

  const renderIcon = () => !!icon && <FontAwesomeIcon fixedWidth icon={icon} />;

  return (
    <span className={base()}>
      {iconPosition === "start" && renderIcon()}
      {children}
      {iconPosition === "end" && renderIcon()}
    </span>
  );
};

export default Badge;
